import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import CreateCustomerModal from "../modals/createCustomerModal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import AwaitingApproval from "./customers/awaitingApproval";
import Allcustomers from "./customers/allCustomers";
import { connect } from "react-redux";
import {
  get_settings,
  pause_user_signup,
  resume_user_signup,
} from "../../redux/actions/adminActions";
import Spinner from "../reusables/spinner";
import DeletedCustomers from "./customers/deletedCustomers";
import Orders from "./customers/transactions/orders";
import Payments from "./customers/transactions/payments";
import { Carousel } from "react-bootstrap";

function Customers({
  customerSignup,
  pauseCustomerSignup,
  resumeCustomerSignup,
  accessToken,
  getSettings,
  settings,
}) {
  const [index, setIndex] = useState(0);
  const [customer, setCustomer] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [create, setCreate] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(0);

  const isDone = () => {
    getSettings(accessToken, () => setLoading(false));
  };

  const nextSlide = (id, customer) => {
    if (id != 0) setSelectedCustomer(id);
    setCustomer(customer);
    setIndex(index + 1);
  };

  const clickHandler = () => {
    setLoading(true);
    if (customerSignup === true) {
      pauseCustomerSignup(accessToken, () => isDone());
    } else {
      resumeCustomerSignup(accessToken, () => isDone());
    }
  };

  useEffect(() => {
    getSettings(accessToken, () => setLoading(false));
  }, [accessToken]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid suppliers">
        <Carousel activeIndex={index} indicators={false} controls={false}>
          <Carousel.Item>
            <div className="spaceBetween mobileBlock">
              <h2 className="sectionText--big textIsBold">
                Customers Managment
              </h2>

              <div className="textIsBold pt-2 mobileAlign d-flex">
                <button
                  className={`${
                    settings?.pause_customers_sign_up == 0
                      ? "btn__dark"
                      : "btn__gray"
                  } hasRadius d-flex`}
                  onClick={clickHandler}
                >
                  {settings?.pause_customers_sign_up == 0
                    ? "Pause Customer Sign-up"
                    : "Resume Customer Sign-up"}{" "}
                  {isLoading && <Spinner />}{" "}
                </button>
                <button
                  className="btn__filled hasRadius mx-2"
                  onClick={() => setCreate(true)}
                >
                  Add/Register Customer
                </button>
              </div>
            </div>

            <Tabs className="pt-3">
              <TabList className="alignOnly sectionText--mid p-0">
                <Tab className="tabHead">Customers</Tab>
                <Tab className="tabHead">Awaiting Verification</Tab>
                <Tab className="tabHead">Deleted Customers</Tab>
              </TabList>

              <TabPanel>
                <Allcustomers next={(e, customer) => nextSlide(e, customer)} />
              </TabPanel>
              <TabPanel>
                <AwaitingApproval />
              </TabPanel>
              <TabPanel>
                <DeletedCustomers />
              </TabPanel>
            </Tabs>
          </Carousel.Item>

          <Carousel.Item>
            <div className="">
              <h2
                className="sectionText--mid textIsBold isClickable alignOnly"
                onClick={() => setIndex(0)}
              >
                <i class="ri-arrow-left-line mx-2"></i>
                {customer}
              </h2>

              <Tabs className="pt-3">
                <TabList className="alignOnly sectionText textIsGray">
                  <Tab className="tabHead">Orders</Tab>
                  <Tab className="tabHead">Payments</Tab>
                </TabList>

                <TabPanel>
                  <Orders selected={selectedCustomer} />
                </TabPanel>
                <TabPanel>
                  <Payments selected={selectedCustomer} />
                </TabPanel>
              </Tabs>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>

      <CreateCustomerModal show={create} handleClose={() => setCreate(false)} />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  settings: state.admin.settings,
  customerSignup: state.admin.userSignup,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getSettings: (token, success) => dispatch(get_settings(token, success)),
  pauseCustomerSignup: (token, success) =>
    dispatch(pause_user_signup(token, success)),
  resumeCustomerSignup: (token, success) =>
    dispatch(resume_user_signup(token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Customers);
